import React from 'react';
import PropTypes from 'prop-types';

import * as constants from './constants'

const Logo = ({ type, size, color, opacity, ...restOfProps }) => {
  const { PATH: path } = constants[ type ];
  const { width: widthBase, height: heightBase } = constants[ type ].SIZE;
  const DIMENSIONS = {
    small: {
      width: widthBase * 0.57,
      height: heightBase * 0.57
    },
    normal: {
      width: widthBase,
      height: heightBase
    },
    large: {
      width: widthBase * 1.43,
      height: heightBase * 1.43
    },
    xlarge: {
      width: widthBase * 2,
      height: heightBase * 2
    }
  }
  const { width, height } = DIMENSIONS[ size ];

  return (
  <>
      <svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox={`0 0 ${widthBase} ${heightBase}`}
        fill={color}
        fillOpacity={opacity}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
      >
        {path}
    </svg>
  </>
  )
}

Logo.propTypes = {
  size: PropTypes.oneOf(constants.SIZES),
  types: PropTypes.oneOf(constants.TYPES),
  opacity: PropTypes.number,
  color: PropTypes.string
};

Logo.defaultProps = {
  type: 'BAO',
  size: 'normal',
  color: '#FFFFFF',
  opacity: 1
};

export default Logo;
